// extracted by mini-css-extract-plugin
export default {"noticeResult":"index_noticeResult_TrFjq","noticeResultText":"index_noticeResultText_bAt0q","noticeResultButton":"index_noticeResultButton_JS5cM"};